/// <reference path="../_references.ts"/>

module App.WorkOrderTemplate {
	angular
		.module('workOrderTemplate', [])
		.config(['$stateProvider', ($stateProvider: ng.ui.IStateProvider) => {}])
		.service('WorkOrderTemplateService', WorkOrderTemplateService.Factory());
}